import React from 'react';
import '../common/headsec.css';

const BookingHero = (props) => {
    return (
        <>
            <div className='hero-booking'>
                <div className='hero-booking__badge'>
                    {props.t1}
                </div>

                <div className='hero-booking__title-wrap'>
                    <div className='hero-booking__title'>
                        {props.t2}
                    </div>

                    <div className='hero-booking__title hero-booking__title--gradient'>
                        {props.t3}
                    </div>
                </div>

                <div className='hero-booking__text'>
                    {props.text}
                </div>
            </div>
        </>
    );
};

export default BookingHero;